export const Crown = () => {
  return (
    <svg
      width={89}
      height={71}
      viewBox="0 0 89 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.502 56.032h58.026l6.031-24.317c.464.078.966.155 1.508.155 4.33 0 7.847-3.557 7.847-7.886 0-4.33-3.518-7.887-7.847-7.887-4.33 0-7.887 3.557-7.887 7.887 0 2.165.89 4.136 2.32 5.566l-10.515 6.418c-2.204 1.353-4.02 1.044-5.567-.967L46.931 19.306a7.846 7.846 0 005.451-7.5c0-4.33-3.556-7.847-7.886-7.847-4.291 0-7.848 3.518-7.848 7.847 0 3.48 2.281 6.456 5.451 7.5L29.071 35.581c-1.314 1.624-2.938 1.701-4.639.696L13.415 29.55a7.863 7.863 0 002.319-5.566c0-4.33-3.518-7.887-7.848-7.887S0 19.654 0 23.984s3.557 7.886 7.886 7.886c.542 0 1.083-.077 1.585-.193l6.031 24.355zm.734 2.976l1.044 4.175c1.315 5.451 3.905 7.616 9.124 7.616h36.223c5.218 0 7.809-2.165 9.123-7.616l1.044-4.175H16.237z"
        fill="#C88E29"
      />
      <path
        d="M15.502 52.073h58.026l6.031-24.316c.464.077.966.154 1.508.154 4.33 0 7.847-3.556 7.847-7.886s-3.518-7.886-7.847-7.886c-4.33 0-7.887 3.556-7.887 7.886 0 2.165.89 4.137 2.32 5.567l-10.515 6.417c-2.204 1.353-4.02 1.044-5.567-.966L46.931 15.347a7.846 7.846 0 005.451-7.5c0-4.33-3.556-7.847-7.886-7.847-4.291 0-7.848 3.518-7.848 7.848 0 3.479 2.281 6.456 5.451 7.5L29.071 31.622c-1.314 1.623-2.938 1.7-4.639.695l-11.017-6.726a7.863 7.863 0 002.319-5.567c0-4.33-3.518-7.886-7.848-7.886S0 15.695 0 20.025s3.557 7.886 7.886 7.886c.542 0 1.083-.077 1.585-.193l6.031 24.355zm.734 2.977l1.044 4.175c1.315 5.45 3.905 7.615 9.124 7.615h36.223c5.218 0 7.809-2.165 9.123-7.615l1.044-4.175H16.237z"
        fill="url(#paint0_linear_6778_379)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6778_379"
          x1={13.2232}
          y1={-13.4763}
          x2={44.5094}
          y2={81.5134}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD278" />
          <stop offset={0.526042} stopColor="#FFC85A" />
          <stop offset={1} stopColor="#FFB727" />
        </linearGradient>
      </defs>
    </svg>
  );
};
